import { StrainAttributes } from "@/custom-types/Strain";
import { moveObjToSortedArray } from "@/utils/moveObjToSortedArray";

export const extractEffects = (rawEffects: StrainAttributes) => {
  return moveObjToSortedArray(rawEffects, "score").filter(
    (rawEffect) => rawEffect.score > 0,
  );
};
